export const STALE_POPOVER_BOOTSTRAP_PLUGINS_CHUNK_RELOAD_KEY = 'bp-popover-bootstrap-plugins-chunk-reload';

let bootstrapPopoverPluginsPromise = null;
let reloadPage = () => {
  window.location.reload({ cache: 'no-cache' });
};
let importPopoverBootstrapPlugins = () => import('./popover-bootstrap-plugins');

/**
 * @param {() => Promise<unknown>} importFn
 * @returns {void}
 */
export function setImportPopoverBootstrapPluginsForTests(importFn) {
  importPopoverBootstrapPlugins = importFn;
}

/**
 * @returns {void}
 */
export function resetImportPopoverBootstrapPluginsForTests() {
  importPopoverBootstrapPlugins = () => import('./popover-bootstrap-plugins');
}

/**
 * @param {() => void} reloadFn
 * @returns {void}
 */
export function setReloadPageForTests(reloadFn) {
  reloadPage = reloadFn;
}

/**
 * @returns {void}
 */
export function resetReloadPageForTests() {
  reloadPage = () => {
    window.location.reload({ cache: 'no-cache' });
  };
}

/**
 * @param {unknown} error
 * @returns {boolean}
 */
export function isStalePopoverBootstrapPluginsChunkError(error) {
  if (!(error instanceof TypeError)) {
    return false;
  }

  if (typeof error.message !== 'string') {
    return false;
  }

  return /(?:failed to fetch|error loading) dynamically imported module/i.test(error.message)
    && /popover-bootstrap-plugins/i.test(error.message);
}

/**
 * @returns {boolean}
 */
export function reloadForStalePopoverBootstrapPluginsChunk() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return false;
  }

  if (window.sessionStorage.getItem(STALE_POPOVER_BOOTSTRAP_PLUGINS_CHUNK_RELOAD_KEY)) {
    return false;
  }

  window.sessionStorage.setItem(STALE_POPOVER_BOOTSTRAP_PLUGINS_CHUNK_RELOAD_KEY, '1');
  reloadPage();
  return true;
}

/**
 * @returns {Promise<unknown>}
 */
export function loadBootstrapPopoverPlugins() {
  if (!bootstrapPopoverPluginsPromise) {
    bootstrapPopoverPluginsPromise = importPopoverBootstrapPlugins().catch((error) => {
      bootstrapPopoverPluginsPromise = null;

      if (isStalePopoverBootstrapPluginsChunkError(error) && reloadForStalePopoverBootstrapPluginsChunk()) {
        return new Promise(() => {});
      }

      throw error;
    });
  }

  return bootstrapPopoverPluginsPromise;
}

/**
 * @returns {void}
 */
export function resetBootstrapPopoverPluginsPromiseForTests() {
  bootstrapPopoverPluginsPromise = null;
}
